import { render } from "./timeModal.vue?vue&type=template&id=215b61fa"
import script from "./timeModal.vue?vue&type=script&lang=js"
export * from "./timeModal.vue?vue&type=script&lang=js"

import "./timeModal.vue?vue&type=style&index=0&id=215b61fa&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/nosecape-leaderboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__